import React from "react";
import styled from "styled-components";

export type Filters = {
  liked: boolean;
  fullSongs: boolean;
  hasPersonas: boolean;
  hideDisliked: boolean;
};

type FiltersModalProps = {
  filters: Filters;
  onChange: (filters: Filters) => void;
  onClose: () => void;
};

export const FiltersModal: React.FC<FiltersModalProps> = ({
  filters,
  onChange,
  onClose,
}) => {
  const handleFilterChange = (key: keyof Filters, value: boolean) => {
    let next: Filters = { ...filters, [key]: value };

    // Взаимоисключающие фильтры: liked и hideDisliked
    if (key === "liked" && value) {
      next.hideDisliked = false;
    }
    if (key === "hideDisliked" && value) {
      next.liked = false;
    }

    onChange(next);
  };

  return (
    <DropdownMenu onClick={(e) => e.stopPropagation()}>
      <DropdownItem>
        <label>
          <span>Liked</span>
          <input
            type="checkbox"
            checked={filters.liked}
            onChange={(e) => handleFilterChange('liked', e.target.checked)}
          />
        </label>
      </DropdownItem>
      <DropdownItem>
        <label>
          <span>Full Songs</span>
          <input
            type="checkbox"
            checked={filters.fullSongs}
            onChange={(e) => handleFilterChange('fullSongs', e.target.checked)}
          />
        </label>
      </DropdownItem>
      <DropdownItem>
        <label>
          <span>Personas</span>
          <input
            type="checkbox"
            checked={filters.hasPersonas}
            onChange={(e) => handleFilterChange('hasPersonas', e.target.checked)}
          />
        </label>
      </DropdownItem>
      <DropdownItem>
        <label>
          <span>Hide Disliked</span>
          <input
            type="checkbox"
            checked={filters.hideDisliked}
            onChange={(e) => handleFilterChange('hideDisliked', e.target.checked)}
          />
        </label>
      </DropdownItem>
    </DropdownMenu>
  );
};

const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(0,0,0,0.12);
  padding: 8px 0;
  min-width: 240px;
  z-index: 20;
`;

const DropdownItem = styled.div`
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  label {
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  input {
    margin-left: 12px;
  }
  &:hover {
    background: #f8f9ff;
  }
`;

